import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../../../Header/actions";

import Siniestro from "./Siniestro/view";
import Prestaciones from "./Prestaciones/view";

import { doPostTagManagerApi } from '../../Empresa/SiniestrosEmpresa/Siniestros/actions'
import jwtDecode from 'jwt-decode';

const headerTitle = "";
class Siniestros extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== headerTitle) {
      this.loadTabs();
    }
  }

  postTagManager({ label, response }, dispatch) {
    // const token = localStorage.getItem('AccessToken');
    // let azureObjectId;
    // if (token) {
    //   const tokenDecoded = jwtDecode(`Bearer ${token}`);
    //   azureObjectId = tokenDecoded.sub.toLowerCase();
    // }
    // dispatch(
    //   doPostTagManagerApi({
    //     action: 'Mis siniestros',
    //     label,
    //     category: 'Trabajador',
    //     id: azureObjectId,
    //     response: response || '',
    //   }),
    // );
    console.log('tagmanager')
  }

  loadTabs = () => {
    const tabs = [];
    tabs.push({ text: "Siniestros", contentId: 0 });
    // if (checkAccess(ids.prestaciones, this.props.userAccessIds)) tabs.push({ text: "Prestaciones económicas", contentId: 1 });
    this.props.dispatch(loadTabs(
      headerTitle,
      "",
      tabs,
      tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return (<Siniestro postTagManager={this.postTagManager} />);
      }
      case 1: {
        return (<Prestaciones />);
      }
      default:
        return <div />;
    }
  }

  render() {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Siniestros);
